import { DefaultSerializationMixin, Serializable } from "../../../tendercuts/models/base";
import { SaleItem, CartTotal } from "@tendercuts/models";
import { PosUser } from '../pos-user/pos-user';

export class PosQuote extends DefaultSerializationMixin
  implements Serializable<PosQuote> {
  public status: string;
  public couponTotalDiscount = 0;
  private reward_points_spend = 0;
  private payment_method: string;
  private coupon_code: string = null;
  private order_id: string;
  public medium: string;
  public tenderCash: number = 0;
  public changeCash: number = 0;
  public transactionId = null;
  public cardNumber = null;
  public cartProducts: SaleItem[] = [];
  private created_at: Date;
  public user: PosUser;
  public totals: CartTotal = new CartTotal();
  public cartBarcodes: string[] = [];
  public plutusTransactionReferenceID: number;
  public isPlutusTransactionApproved: boolean;

  constructor() {
    super();
  }

  get rewardPointsSpend() {
    return this.reward_points_spend;
  }

  set rewardPointsSpend(points) {
    this.reward_points_spend = points;
  }

  get paymentMethod() {
    return this.payment_method;
  }

  set paymentMethod(method) {
    this.payment_method = method;
  }

  get couponCode() {
    return this.coupon_code;
  }

  set couponCode(code) {
    this.coupon_code = code;
  }

  get createdAt() {
    return this.created_at;
  }

  set orderId(id) {
    this.order_id = id;
  }

  get orderId() {
    return this.order_id;
  }

  get availableRewardPoints() {
    return this.user.rewards - this.totals.rewardPointsSpend;
  }

  /**
   * If any virtual product add in cart,
   * return true 
   * else false
   */
  get isElite(): boolean {
    if(this.cartProducts.some((item: SaleItem) => item.isSubscription))
      return true;
    if(this.user && this.user.isElite)
      return true;
  
    return false;
  }

  deserialize(input) {
    if (!input) {
      return this;
    }
    this.status = input.status;
    if (input.user) {
      this.user = new PosUser().deserialize(input.user);
    }
    this.reward_points_spend = input.reward_points_spend;
    this.payment_method = input.payment_method;
    this.coupon_code = input.coupon_code;
    this.created_at = input.created_at;
    this.order_id = input.order_id;
    input.cartProducts.forEach(product => {
      if (product._product) {
        this.cartProducts.push(SaleItem.buildFromProduct(product._product, product.quantity));
      } else {
        this.cartProducts = input.cartProducts;
      }
    });
    this.medium = input.medium;
    this.totals = input.totals;
    this.tenderCash = input.tenderCash;
    this.changeCash = input.changeCash;
    this.cartBarcodes = input.cartBarcodes;
    this.plutusTransactionReferenceID = input.plutusTransactionReferenceID;
    this.isPlutusTransactionApproved = input.isPlutusTransactionApproved;
    return this;
  }

  eavDeserialize(input) {
    super.eavDeserialize(input);
    return this;
  }
}
